module.exports = __webpack_public_path__ + "static/media/logo-powered.7f6a585c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/logo-powered.svg
// module id = 1258
// module chunks = 19